import script from "./AddVenue.vue?vue&type=script&setup=true&lang=js"
export * from "./AddVenue.vue?vue&type=script&setup=true&lang=js"

import "./AddVenue.vue?vue&type=style&index=0&id=f7f3da5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f7f3da5a"]])

export default __exports__